import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../contexts/PermissionsContext';

const PrivateRoutes = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { permissionsLoading, permittedRoutes } = usePermissions();
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (permissionsLoading || loading) {
    return null;
  }

  // const restrictedRoutesForUser = ["/permissions"];
  const restrictedRoutesForUser = ['/any_secure_route_that_is_only_for_admin'];

  if (!permittedRoutes.includes(location.pathname)) {
    console.log(
      'dont have permission to access this route....',
      location.pathname
    );
    if (permittedRoutes.includes('/')) {
      return <Navigate to="/" replace />;
    } else {
      return <Navigate to="/setting" replace />;
    }
  }

  if (
    restrictedRoutesForUser.includes(location.pathname) &&
    user.role !== 'admin'
  ) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
export default PrivateRoutes;
